import { GetStaticProps, GetStaticPropsContext, NextPage, InferGetStaticPropsType, GetStaticPaths } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { Fragment } from 'react'

import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import StudyTipsContent from '~/study-tips/pages/StudyTipsContent.page'
import { usePageTitle } from '~/utils/tags'
import { getStudyTipsContent } from '~/../utils/data-fetch/study-tips/study-tips.query'
import Metatags from '~/components/Metadata/Metatags'

const StudyTipsContentPage: NextPage = ({
  contentDetails,
  contentKey,
  itemKey,
}: InferGetStaticPropsType<typeof getStaticProps>): React.ReactElement => {
  const { name = '', metaDescription } = contentDetails?.item || {}

  return (
    <Fragment>
      <Metatags contentType="article" metaDescription={metaDescription} title={usePageTitle(name)} />

      <DefaultLayout zeroPadding>
        <StudyTipsContent contentDetails={contentDetails} contentKey={+contentKey} itemKey={itemKey} />
      </DefaultLayout>
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale, params }: GetStaticPropsContext) => {
  const { itemKey, contentKey } = params
  const contentDetails = await getStudyTipsContent(locale ?? 'en', itemKey as string, +contentKey)

  if (!contentDetails?.item) return { notFound: true }

  return {
    props: {
      ...(await serverSideTranslations(locale as string, [
        'studyTips',
        'encyclopedia',
        'generics',
        ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
        ...COMMON_TRANSLATION_MODULE_NAMES,
      ])),
      contentDetails,
      contentKey,
      itemKey,
    },
  }
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

export default StudyTipsContentPage
